import { getStore as getMailStore } from '../../store/Store';

export const getMailItemFromItemId = (itemId: string) => getMailStore().items.get(itemId);
